import React, { useState, useEffect } from 'react';
import { notification } from '../../component/hocs/notification';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import { mainurl, imgurl } from '../../Mainurl';
import * as XLSX from 'xlsx/xlsx.mjs';

import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Input,
    Label,
    InputGroup,
    InputGroupText,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Badge,
    Spinner,
    Alert
} from 'reactstrap';
import {
    FaEye,
    FaEdit,
    FaPlusCircle,
    FaClipboardList,
    FaSearch,
    FaDownload,
    FaLeaf,
    FaImage,
    FaCheckCircle,
    FaFilter
} from 'react-icons/fa';

const CropMaster = () => {
    const [mode, setMode] = useState("1");
    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [cropTypeOpt, setCropTypeOpt] = useState([]);
    const [cropType, setCropType] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    
    // Modal states
    const [viewModal, setViewModal] = useState(false);
    const [modalData, setModalData] = useState({});

    useEffect(() => {
        loadCropTypes();
    }, []);

    const loadCropTypes = async () => {
        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": sessionStorage.getItem('user_id'),
                "lang_id": 1
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/box_crop_type_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            setCropTypeOpt(response.data);
        } catch (error) {
            let notify = notification({
                message: "Failed to load crop types. Please try again.",
                type: 'error'
            });
            notify();
        }
    };

    const crop_list = async (e) => {
        e.preventDefault();
        
        if (!cropType || cropType === '0') {
            let notify = notification({
                message: "Please select a crop type first",
                type: 'warning'
            });
            notify();
            return;
        }

        setLoading(true);
        setTableData([]);
        setFilteredData([]);

        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "user_id": sessionStorage.getItem('user_id'),
                "crop_type_id": cropType,
                "lang_id": 1
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Master/box_crop_master_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON' }
            });

            let list = response.data.map((row, index) => {
                return {
                    sl: index + 1,
                    name: row.crop_name,
                    name_h: row.crop_name_ne,
                    crop_img: row.photo ? (
                        <img 
                            className='rounded shadow-sm cursor-pointer' 
                            src={imgurl + row.photo} 
                            height="40px" 
                            width="40px"
                            style={{ objectFit: 'cover' }}
                            alt="crop"
                            onClick={() => viewImageHandler(row)}
                        />
                    ) : (
                        <div className="d-flex align-items-center justify-content-center bg-light rounded" 
                             style={{ width: '40px', height: '40px' }}>
                            <FaImage className="text-muted" size={16} />
                        </div>
                    ),
                    status: (
                        <Badge color="success" pill className="d-flex align-items-center gap-1">
                            <FaCheckCircle size={12} />
                            Active
                        </Badge>
                    ),
                    action: (
                        <div className="d-flex gap-1">
                            <Button
                                color="info"
                                size="sm"
                                outline
                                className="d-flex align-items-center gap-1"
                                onClick={() => viewCropHandler(row)}
                            >
                                <FaEye size={12} />
                                View
                            </Button>
                            <Button
                                color="warning"
                                size="sm"
                                outline
                                className="d-flex align-items-center gap-1"
                            >
                                <FaEdit size={12} />
                                Edit
                            </Button>
                        </div>
                    ),
                    rawData: row
                };
            });

            setTableData(list);
            setFilteredData(list);

            let notify = notification({
                message: `${list.length} crops loaded successfully`,
                type: 'success'
            });
            notify();
        } catch (error) {
            let notify = notification({
                message: "Failed to load crops. Please try again.",
                type: 'error'
            });
            notify();
        } finally {
            setLoading(false);
        }
    };

    const viewCropHandler = (cropData) => {
        setModalData(cropData);
        setViewModal(true);
    };

    const viewImageHandler = (cropData) => {
        setModalData(cropData);
        setViewModal(true);
    };

    const download_excel_handler = async () => {
        if (tableData.length === 0) {
            let notify = notification({
                message: "No data available for download",
                type: 'warning'
            });
            notify();
            return;
        }

        setDownloadLoading(true);

        try {
            const selectedCropType = cropTypeOpt.find(type => type.crop_type_id == cropType);
            
            let list = tableData.map((row, index) => {
                return {
                    sl_no: index + 1,
                    crop_type: selectedCropType?.crop_type_name || 'N/A',
                    crop_name_english: row.name,
                    crop_name_hindi: row.name_h,
                    status: 'Active'
                };
            });

            let wb = XLSX.utils.book_new(),
                ws = XLSX.utils.json_to_sheet(list);
            XLSX.utils.book_append_sheet(wb, ws, "Crop_Master_Report");
            XLSX.writeFile(wb, `crop_master_report_${new Date().toISOString().split('T')[0]}.xlsx`);

            let notify = notification({
                message: "Excel report downloaded successfully!",
                type: 'success'
            });
            notify();
        } catch (error) {
            let notify = notification({
                message: "Download failed. Please try again.",
                type: 'error'
            });
            notify();
        } finally {
            setDownloadLoading(false);
        }
    };

    // Search functionality
    const handleSearch = (value) => {
        setSearchTerm(value);
        if (value === '') {
            setFilteredData(tableData);
        } else {
            const filtered = tableData.filter(item =>
                item.name.toLowerCase().includes(value.toLowerCase()) ||
                item.name_h.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredData(filtered);
        }
    };

    const columns = [
        {
            name: '#',
            selector: row => row.sl,
            sortable: true,
            width: '70px',
            center: true
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaLeaf size={12} />
                    Crop Name (English)
                </div>
            ),
            selector: row => row.name,
            sortable: true,
            cell: row => (
                <div className="fw-medium text-primary">
                    {row.name}
                </div>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaLeaf size={12} />
                    Crop Name (Hindi)
                </div>
            ),
            selector: row => row.name_h,
            sortable: true,
            cell: row => (
                <div className="text-muted">
                    {row.name_h || 'N/A'}
                </div>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaImage size={12} />
                    Image
                </div>
            ),
            selector: row => row.crop_img,
            sortable: false,
            center: true,
            width: '100px'
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaCheckCircle size={12} />
                    Status
                </div>
            ),
            selector: row => row.status,
            sortable: false,
            center: true,
            width: '120px'
        },
        {
            name: 'Actions',
            selector: row => row.action,
            sortable: false,
            center: true,
            width: '150px'
        }
    ];

    return (
        <>
            <Header />
            <Page title='Crop Master' breadcrumbs='Home / Master Data / Crop Master'>
                <Row className='p-3'>
                    {mode === "1" && (
                        <Col xs={12}>
                            {/* Filter and Action Bar */}
                            <Card className='mb-4 border-0 shadow-sm'>
                                <CardBody className="py-3">
                                    <Row className="align-items-end">
                                        <Col md={3}>
                                            <Label for="cropType" className="form-label">
                                                <FaFilter className="me-1" size={12} />
                                                Crop Type
                                            </Label>
                                            <Input
                                                id="cropType"
                                                bsSize="sm"
                                                type="select"
                                                value={cropType}
                                                onChange={(e) => setCropType(e.target.value)}
                                                className="form-select"
                                            >
                                                <option value="0">--Select Crop Type--</option>
                                                {cropTypeOpt.map((type, index) => (
                                                    <option key={index} value={type.crop_type_id}>
                                                        {type.crop_type_name}
                                                    </option>
                                                ))}
                                            </Input>
                                        </Col>
                                        <Col md={3}>
                                            <div className="d-flex gap-2">
                                                <Button
                                                    color='primary'
                                                    size="sm"
                                                    onClick={crop_list}
                                                    disabled={loading || !cropType || cropType === '0'}
                                                    className="d-flex align-items-center gap-2"
                                                >
                                                    {loading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaClipboardList size={14} />
                                                    )}
                                                    {loading ? 'Loading...' : 'Get List'}
                                                </Button>
                                                <Button
                                                    color='secondary'
                                                    size="sm"
                                                    onClick={download_excel_handler}
                                                    disabled={downloadLoading || tableData.length === 0}
                                                    className="d-flex align-items-center gap-2 text-white"
                                                >
                                                    {downloadLoading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaDownload size={14} />
                                                    )}
                                                    {downloadLoading ? 'Downloading...' : 'Download Excel'}
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <Button
                                                color='success'
                                                size="sm"
                                                className="d-flex align-items-center gap-2"
                                            >
                                                <FaPlusCircle size={14} />
                                                Add New Crop
                                            </Button>
                                        </Col>
                                        <Col md={3}>
                                            <InputGroup size="sm">
                                                <InputGroupText className="bg-light border-end-0">
                                                    <FaSearch className="text-muted" />
                                                </InputGroupText>
                                                <Input
                                                    type="search"
                                                    placeholder='Search crops...'
                                                    value={searchTerm}
                                                    onChange={(e) => handleSearch(e.target.value)}
                                                    className="border-start-0"
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            {/* Statistics Cards */}
                            {tableData.length > 0 && (
                                <Row className="mb-4">
                                    <Col md={3}>
                                        <Card className="border-0 bg-primary text-white">
                                            <CardBody className="text-center py-3">
                                                <FaLeaf size={24} className="mb-2" />
                                                <h5 className="mb-0">{tableData.length}</h5>
                                                <small>Total Crops</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-success text-white">
                                            <CardBody className="text-center py-3">
                                                <FaCheckCircle size={24} className="mb-2" />
                                                <h5 className="mb-0">{tableData.length}</h5>
                                                <small>Active Crops</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-info text-white">
                                            <CardBody className="text-center py-3">
                                                <FaImage size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {tableData.filter(item => item.rawData.photo).length}
                                                </h5>
                                                <small>With Images</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-warning text-white">
                                            <CardBody className="text-center py-3">
                                                <FaFilter size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {cropTypeOpt.find(type => type.crop_type_id == cropType)?.crop_type_name || 'N/A'}
                                                </h5>
                                                <small>Selected Type</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {/* Main Data Table */}
                            <Card className='border-0 shadow-sm'>
                                <CardHeader className="bg-white border-bottom">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h5 className="mb-0">Crop Master Data</h5>
                                            <small className='text-muted'>
                                                {filteredData.length > 0 ?
                                                    `Showing ${filteredData.length} of ${tableData.length} crops` :
                                                    'No crops found'
                                                }
                                            </small>
                                        </div>
                                        {searchTerm && (
                                            <Badge color="secondary" className="ms-2">
                                                Filtered: {filteredData.length}
                                            </Badge>
                                        )}
                                    </div>
                                </CardHeader>
                                <CardBody className="p-0">
                                    {tableData.length === 0 && !loading ? (
                                        <Alert color="info" className="m-3 text-center">
                                            <FaLeaf size={48} className="mb-3 text-muted" />
                                            <p className="mb-2">No crops loaded yet</p>
                                            <small>Select a crop type and click "Get List" to fetch crop data</small>
                                        </Alert>
                                    ) : (
                                        <DataTable
                                            title=""
                                            customStyles={custTableStyles}
                                            columns={columns}
                                            data={filteredData}
                                            highlightOnHover
                                            responsive
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                            progressPending={loading}
                                            progressComponent={
                                                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                                    <Spinner color="primary" />
                                                    <p className="mt-2 text-muted">Loading crops...</p>
                                                </div>
                                            }
                                            noDataComponent={
                                                <div className="text-center py-5">
                                                    <FaSearch size={48} className="text-muted mb-3" />
                                                    <p className="text-muted">No crops match your search criteria</p>
                                                </div>
                                            }
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    )}
                </Row>
            </Page>

            {/* Enhanced Modal for Crop Details */}
            <Modal
                centered
                scrollable
                size="md"
                isOpen={viewModal}
                toggle={() => setViewModal(!viewModal)}
                className="modal-dialog-scrollable"
            >
                <ModalHeader
                    toggle={() => setViewModal(!viewModal)}
                    className="bg-light border-bottom"
                >
                    <div className="d-flex align-items-center gap-2">
                        <FaLeaf className="text-success" />
                        <div>
                            <h5 className="mb-0">Crop Details</h5>
                            <small className="text-muted">
                                Crop Information
                            </small>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {modalData && (
                        <div className="row">
                            <div className="col-12 text-center mb-3">
                                {modalData.photo ? (
                                    <img
                                        src={imgurl + modalData.photo}
                                        alt={modalData.crop_name}
                                        className="img-fluid rounded shadow"
                                        style={{ maxHeight: '200px', objectFit: 'cover' }}
                                    />
                                ) : (
                                    <div className="bg-light rounded d-flex align-items-center justify-content-center" 
                                         style={{ height: '200px' }}>
                                        <FaImage size={48} className="text-muted" />
                                    </div>
                                )}
                            </div>
                            <div className="col-12">
                                <table className="table table-borderless">
                                    <tbody>
                                        <tr>
                                            <td><strong>English Name:</strong></td>
                                            <td>{modalData.crop_name}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Hindi Name:</strong></td>
                                            <td>{modalData.crop_name_ne || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Status:</strong></td>
                                            <td>
                                                <Badge color="success" pill>
                                                    <FaCheckCircle className="me-1" size={12} />
                                                    Active
                                                </Badge>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>

            <Footer />
        </>
    );
};

export default CropMaster;